import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15493c0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = {
  key: 0,
  class: "com_sec1"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner1" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title_left" }, "ワンストップガイドトップ管理")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "error-message"
}
const _hoisted_8 = { class: "" }
const _hoisted_9 = { style: {"width":"100%"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"5%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"55%"} })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode(" カテゴリ ")
], -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-control-title" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_17 = { style: {"width":"100%","margin-bottom":"5px"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"52%"} })
], -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "table table-bordered" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col_selection" }, "選択"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "col_id",
      style: {"text-align":"center"}
    }, "ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_subCategory" }, "サブカテゴリ"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_title" }, "タイトル"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_keisaiKikan" }, "掲載期間")
  ])
], -1))
const _hoisted_23 = {
  "data-name": "mSelection",
  style: {"text-align":"center"}
}
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = {
  "data-name": "mContentsId",
  style: {"text-align":"center"}
}
const _hoisted_26 = { "data-name": "mSubCategoryName" }
const _hoisted_27 = { "data-name": "mTitle" }
const _hoisted_28 = {
  style: {"text-align":"center"},
  "data-name": "mHyoujiKIkan"
}
const _hoisted_29 = { class: "form-inline flex-container" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, null, -1))
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = { class: "" }
const _hoisted_35 = { class: "table table-bordered" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col_selection" }, "削除"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_id" }, "ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_subCategory" }, "サブカテゴリ"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_title" }, "タイトル"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_keisaiKikan" }, "掲載期間")
  ])
], -1))
const _hoisted_37 = {
  "data-name": "mBtnUpdate",
  style: {"text-align":"center"}
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  "data-name": "mContentsId",
  style: {"text-align":"center"}
}
const _hoisted_40 = { "data-name": "mSubCategoryName" }
const _hoisted_41 = { "data-name": "mTitle" }
const _hoisted_42 = {
  style: {"text-align":"center"},
  "data-name": "mHyoujiKIkan"
}
const _hoisted_43 = { class: "form-inline flex-container" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, null, -1))
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.isDataFetched)
            ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                _hoisted_6,
                (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("table", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_11,
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("select", {
                            id: "bannerArea",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCategory) = $event)),
                            disabled: !_ctx.isSearchMode
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item.categoryId,
                                value: item.categoryId
                              }, _toDisplayString(item.categoryName), 9, _hoisted_13))
                            }), 128))
                          ], 8, _hoisted_12), [
                            [_vModelSelect, _ctx.selectedCategory]
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("button", {
                            type: "button",
                            name: "btnSearch",
                            class: "btn btn-primary",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args))),
                            disabled: !_ctx.isSearchMode
                          }, " 検索 ", 8, _hoisted_15)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            name: "btnClearH",
                            class: "btn btn-footer btn-primary",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                          }, " クリア ")
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_16,
                _createElementVNode("div", null, [
                  _createElementVNode("table", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            id: "titleSerch",
                            placeholder: "絞込キーワードを入力してください",
                            type: "text",
                            maxlength: "255",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchText) = $event)),
                            disabled: _ctx.isSearchMode
                          }, null, 8, _hoisted_19), [
                            [_vModelText, _ctx.searchText]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("table", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.narrowList, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.contentsId
                        }, [
                          _createElementVNode("td", _hoisted_23, [
                            _withDirectives(_createElementVNode("input", {
                              id: "mSelection",
                              "onUpdate:modelValue": ($event: any) => ((item.selection) = $event),
                              type: "checkbox",
                              class: "form-check-input"
                            }, null, 8, _hoisted_24), [
                              [_vModelCheckbox, item.selection]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_25, _toDisplayString(item.contentsId), 1),
                          _createElementVNode("td", _hoisted_26, _toDisplayString(item.subCategoryName), 1),
                          _createElementVNode("td", _hoisted_27, _toDisplayString(item.title), 1),
                          _createElementVNode("td", _hoisted_28, _toDisplayString(item.keisaikikanStart) + " ～" + _toDisplayString(item.keisaikikanEnd), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnUpdate",
                        class: "btn btn-middle btn-primary",
                        disabled: _ctx.isSearchMode,
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addDispList && _ctx.addDispList(...args)))
                      }, " 表示対象に追加 ", 8, _hoisted_32)
                    ])
                  ])
                ]),
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("table", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dispList, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.contentsId
                        }, [
                          _createElementVNode("td", _hoisted_37, [
                            _createElementVNode("button", {
                              type: "button",
                              name: "mBtnUpdate",
                              class: "btn btn-primary btn-sm",
                              onClick: ($event: any) => (_ctx.removeFromDisplayList(item.contentsId))
                            }, " 削除 ", 8, _hoisted_38)
                          ]),
                          _createElementVNode("td", _hoisted_39, _toDisplayString(item.contentsId), 1),
                          _createElementVNode("td", _hoisted_40, _toDisplayString(item.subCategoryName), 1),
                          _createElementVNode("td", _hoisted_41, _toDisplayString(item.title), 1),
                          _createElementVNode("td", _hoisted_42, _toDisplayString(item.keisaikikanStart) + " ～" + _toDisplayString(item.keisaikikanEnd), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnBack",
                        class: "btn btn-footer btn-primary",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
                      }, " 戻る "),
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnClear",
                        class: "btn btn-footer btn-primary",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                      }, " クリア "),
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnUpdate",
                        class: "btn btn-footer btn-primary",
                        disabled: _ctx.isSearchMode,
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onCommit && _ctx.onCommit(...args)))
                      }, " 確定 ", 8, _hoisted_46)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}